'use client';

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { queryKeys } from '@/hooks/query-keys';
import { useUIStore } from '@/store/ui-store';

/**
 * Fetches the current season from the API and syncs to Zustand.
 * Polls every 60 seconds so enrollment status updates automatically.
 * This is a public endpoint — no auth token required.
 */
export function useCurrentSeason() {
  return useQuery({
    queryKey: queryKeys.season.current(),
    queryFn: async () => {
      const { response, result } = await api.getCurrentSeason();
      if (!response.ok || !result) {
        throw new Error('Failed to fetch current season');
      }
      return result;
    },
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    retry: 1,
    select: (data) => {
      // Sync to Zustand on every successful fetch
      useUIStore.getState().setCurrentSeason(data);
      return data;
    },
  });
}
